<template>
  <div class="work-page">
    <h2 class="title">工作经历</h2>
    <van-form :submit-on-enter="false" :show-error-message="false" @submit="onSubmit">
      <van-field
        v-model="workForm.company_name"
        name="company_name"
        maxlength="25"
        label="公司名称"
        placeholder="请填写"
        :class="{'field-focus': focuseModel === 'f1'}"
        @focus="filedFocus('f1')"
        @blur="filedFocus('')"
        :rules="[{ required: true, message: '' }]"
      />
      <van-field
        v-model="workForm.job_title"
        name="job_title"
        maxlength="25"
        label="职位名称"
        placeholder="请填写"
        :class="{'field-focus': focuseModel === 'f2'}"
        @focus="filedFocus('f2')"
        @blur="filedFocus('')"
        :rules="[{ required: true, message: '' }]"
      />
      <van-field
        v-model="workForm.trade"
        name="trade"
        maxlength="25"
        label="所在行业"
        placeholder="请填写"
        :class="{'field-focus': focuseModel === 'f3'}"
        @focus="filedFocus('f3')"
        @blur="filedFocus('')"
        :rules="[{ required: true, message: '' }]"
      />

      <van-field
        :value="workForm.begin_date"
        name="begin_date"
        label="开始时间"
        placeholder="请选择"
        class="field-arrow"
        :class="{'field-focus': focuseModel === 'f4'}"
        readonly
        clickable
        @focus="filedFocus('f4')"
        @blur="filedFocus('')"
        @click="selectDatePicker('begin_date')"
        :rules="[{ required: true, message: '' }]"
      />

      <van-field
        :value="workForm.end_date"
        name="end_date"
        label="结束时间"
        placeholder="请选择"
        :class="{'field-focus': focuseModel === 'f5'}"
        class="field-arrow"
        readonly
        clickable
        @focus="filedFocus('f5')"
        @blur="filedFocus('')"
         @click="selectDatePicker('end_date')"
         :rules="[{ required: true, message: '' }]"
      />

      <van-field
        v-model="workForm.job_content"
        name="job_content"
        label="工作内容"
        type="textarea"
        autosize
        rows="1"
        placeholder="请填写"
         :class="{'field-focus': focuseModel === 'f6'}"
        class="field-arrow field-textarea"
        readonly
        @focus="filedFocus('f6')"
        @blur="filedFocus('')"
        @click="go('ResumeWorkContent')"
        :rules="[{ required: true, message: '' }]"
      />

      <van-field
        v-model="workForm.performance"
        name="performance"
        label="工作业绩"
        type="textarea"
        autosize
        rows="1"
        placeholder="请填写"
        :class="{'field-focus': focuseModel === 'f7'}"
        class="field-arrow field-textarea"
        readonly
        @focus="filedFocus('f7')"
        @blur="filedFocus('')"
        @click="go('ResumeWorkAchievement')"
        :rules="[{ required: true, message: '' }]"
      />

      <van-popup class="popup-datetime" v-model="showPicker" :close-on-popstate="true" position="bottom">
        <van-datetime-picker
          v-model="currentDate"
          type="year-month"
          title="选择年月"
          :min-date="minDate"
          :max-date="maxDate"
          :formatter="formatter"
          @confirm="onConfirm"
          @cancel="showPicker = false"
        />
      </van-popup>
      <div class="submit-content">
        <p v-if="workForm.id" class="submit-btn-cancel" @click="delWork"><span>删除</span></p>
        <van-button class="submit-btn" :class="{'disabled':!isVaild}"  type="info" native-type="submit"><span>保存</span></van-button>
      </div>
    </van-form>

  </div>
</template>

<script>
import dayjs from 'dayjs'
import { mapState } from "vuex";
import { Dialog } from 'vant';
import cookies from "@/libs/util.cookies";
import util from "../../../libs/util";
export default {
  name: 'ResumeWork',
  data() {
    return {
      username:'',
      password:'',
      workForm:{
        id:this.$route.params.workId,
        user_id:cookies.get('uid') || '',
        company_name:'',
        job_title:'',
        trade:'',
        begin_date:'',
        end_date:'',
        job_content:'',
        performance:''
      },
      showPicker:false,
      focuseModel:'',
      minDate: new Date(1990, 0, 1),
      maxDate:new Date(new Date().getFullYear() + 10, 11, 31),
      currentDate:new Date(),
      pickerType:'',
      isVaild:false,
      isDel:false,
    };
  },
  computed: {
    ...mapState("history", ["history"]),
  },
  watch: {
    workForm: {
      immediate: true,
      deep: true,
      handler(newValue) {
        if(newValue){
          this.isVaild = newValue.company_name && newValue.job_title && newValue.trade && newValue.begin_date && newValue.end_date && newValue.job_content && newValue.performance
        }
      }
    }
  },
  mounted() {
    this.init()
  },
  created() {

    const shareParam = {
      title: "卫宁健康期待您的加入",
      desc: "正在热招",
      link: process.env.VUE_APP_BASEURL +'#/',
      imgUrl: process.env.VUE_APP_SHARE_IMG_URL
    }
    util.initWXSdk(shareParam)
  },
  methods: {
    init(){
      this.getDetail()
    },
    getDetail(){

      let preRoute = ''
      try {
        preRoute = this.history[this.history.length-2]
      } catch (error) {
        preRoute = ''
      }

      if(preRoute === 'ResumeWorkContent' || preRoute === 'ResumeWorkAchievement'){
        window.scrollTo(0,50000);
      }

      if(this.workForm.id){
        this.$api.RESUME_API_WORK_DETAIL({id:this.workForm.id}).then(res =>{
          this.workForm = res || {};
          if(this.workForm.begin_date){
            this.workForm.begin_date = dayjs(res.begin_date).format('YYYY-MM');
          }
          if(this.workForm.end_date){
            this.workForm.end_date = dayjs(res.end_date).format('YYYY-MM');
          }
          if(preRoute === 'ResumeWorkContent' || preRoute === 'ResumeWorkAchievement'){
            this.getCatchDetail()
          }else{
            sessionStorage.setItem('workDetail' ,JSON.stringify(res))
          }
        })
      }else{
        if(preRoute === 'ResumeWorkContent' || preRoute === 'ResumeWorkAchievement'){
          this.getCatchDetail()
        }else{
          sessionStorage.setItem('workDetail' ,JSON.stringify(this.workForm))
        }
      }
    },
    getCatchDetail(){
      try {
        let data = JSON.parse(sessionStorage.getItem('workDetail'))
        if(data.id === this.workForm.id && data.user_id === this.workForm.user_id){
          this.workForm = data
          this.workForm.job_content = data.job_content
          this.workForm.performance = data.performance
        }
      } catch (error) {
        this.workForm.job_content = ''
        this.workForm.performance = ''
      }
    },
    formatter(type, val) {
      if (type === 'year') {
        return `${val}年`;
      } else if (type === 'month') {
        return `${val}月`;
      }
      return val;
    },
    onSubmit(){
      let data = {
        ...this.workForm
      }
      data.begin_date = dayjs(new Date(this.workForm.begin_date)).format('YYYY-MM-DD')
      data.end_date = dayjs(new Date(this.workForm.end_date)).format('YYYY-MM-DD')
      this.$api.RESUME_API_WORK(data).then(() =>{
        this.$router.push({name: 'Resume'})
      })
    },
    filedFocus(value){
      this.focuseModel = value
    },
    go(name){
      sessionStorage.setItem('workDetail' ,JSON.stringify(this.workForm))
      this.$router.push( { name: name, params: {workId:this.workForm.id} } )
    },
    selectDatePicker(key){
      this.pickerType = key
      if(this.workForm[this.pickerType]){
        this.currentDate = new Date(this.workForm[this.pickerType])
      }
      this.showPicker = true
    },
    onConfirm(time) {
      this.workForm[this.pickerType] = dayjs(time).format('YYYY-MM');
      this.showPicker = false;
    },
    delWork(){
      Dialog.confirm({
        message: '确认删除该工作经历？',
        className:'dialog-confirm',
        confirmButtonColor:'#2E5DD2'
      })
        .then(() => {
          // on confirm
          this.$api.RESUME_API_WORK_DELETE([this.workForm.id]).then(() =>{
            this.$router.push({name: 'Resume'})
          })
        })
        .catch(() => {
          // on cancel
        });
    }
  },
}
</script>

<style scoped>
  .work-page{
    text-align:left;
    padding-bottom:85px;
  }
  .work-page .title{
    font-size:24px;
    color:#333;
    font-weight: bold;
    padding:10px 20px;
    margin:10px 0 0 0;
  }

  .submit-content{
    display:flex;
    justify-content: space-between;
    position:fixed;
    bottom:0px;
    left:0;
    width:calc(100vw - 40px);
    padding:10px 20px 20px 20px;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%);
    font-weight: bold;
  }

  .submit-btn{
    flex:1;
    height:44px;
    background: linear-gradient(90deg, #3871FF 0%, #2E5DD2 100%);
    border-radius: 22px;
    font-size:16px;
    color:#fff;
  }

  .submit-btn.disabled span{
    opacity:0.5;
  }

  .submit-btn-cancel{
    width:84px;
    margin:0;
    margin-right:15px;
    height:44px;
    border-radius: 22px;
    font-size:16px;
    color:#333;
    border: 1px solid #EAEDF0;
    background:#fff;
  }

  .submit-btn-cancel span{
    display:block;
    text-align: center;
    line-height:44px;
  }

  ::v-deep .submit-btn.van-button--disabled{
    opacity:1;
  }

  ::v-deep .submit-btn.van-button--disabled span{
    opacity:0.5;
  }

  ::v-deep .van-cell{
    display:block;
    line-height:28px;
    padding:13px 20px;
    font-size:16px;
    color:#333;
    border-color:#F1F4F6;
  }

  /* ::v-deep .van-field__error-message{
    display:none;
  } */

  ::v-deep .van-cell__title{
    font-size:12px;
    color:#999;
    padding-bottom:5px;
  }

  .field-focus::after{
    border-color:#3163E0;
    transform: scaleY(1);
  }

  ::v-deep .field-arrow .van-cell__value{
   position: relative;
   padding-right:20px;
  }

  ::v-deep .field-arrow .van-cell__value::after{
    display:block;
    content:'';
    width:19px;
    height:16px;
    background:url(../../../assets/images/mine/icon-arrow.png);
    background-size:19px 16px;
    position: absolute;
    right:0;
    top:0;
    margin:8px 0;
  }

  ::v-deep .van-picker__confirm{
    color:#3871FF;
  }

  ::v-deep .field-textarea .van-field__control{
    max-height:60px;
    overflow:hidden;
  }

  ::v-deep .popup-datetime{
    border-radius:15px 15px 0 0;
  }

</style>

